import { render, staticRenderFns } from "./Rule20ApplicationInstructions.vue?vue&type=template&id=202b92dc"
import script from "./Rule20ApplicationInstructions.vue?vue&type=script&lang=ts"
export * from "./Rule20ApplicationInstructions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports